import { create, METHOD } from '../utils'

export default {

    code: (props: { phone: string, type: number }) => create({
        url: "/web/verificationCode",
        method: METHOD.POST
    })(props),

    register: (props: { account: string, password: string, verificationCode: string, msgId: string | number }) => create({
        url: "/web/v1/register",
        method: METHOD.POST
    })(props),

    retrieve: (props: { account: string, password: string, verificationCode: string, msgId: string | number }) => create({
        url: "/web/v1/findPW",
        method: METHOD.POST
    })(props),

}